import { useTranslation } from "react-i18next";

const LANGS = [
  { code: "pt", label: "PT", name: "Português", htmlLang: "pt-BR" },
  { code: "en", label: "EN", name: "English", htmlLang: "en" },
  { code: "es", label: "ES", name: "Español", htmlLang: "es-ES" },
] as const;

export default function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const current = i18n.resolvedLanguage ?? i18n.language;

  return (
    <div
      role="group"
      aria-label={t("common.language")}
      className="flex items-center font-mono text-[11px] tracking-[0.14em] select-none"
    >
      {LANGS.map(({ code, label, name, htmlLang }, i) => {
        const active = current === code;

        return (
          <div key={code} className="flex items-center">
            {i > 0 && (
              <span aria-hidden="true" className="mx-1.5 h-3 w-px bg-line" />
            )}
            <button
              type="button"
              lang={htmlLang}
              title={name}
              aria-current={active ? "true" : undefined}
              onClick={() => i18n.changeLanguage(code)}
              className={`cursor-pointer transition-colors ${
                active
                  ? "text-brand dark:text-white"
                  : "text-ink-subtle hover:text-brand dark:text-[#8a8a8a] dark:hover:text-white"
              }`}
            >
              {label}
              <span className="sr-only"> — {name}</span>
            </button>
          </div>
        );
      })}
    </div>
  );
}
